import { Fragment, useEffect, useState } from 'react';
import Dashboard from '../Admin/Dashboard/Dashboard';
import CurrentDate from '../Admin/CurrentDate';
import Loader from '../Admin/Dashboard/Loader';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import baseApi from '../api';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import '../../index.css';

const EditCaseStudyCategory = (props) => {
  const [isLoading, setIsloading] = useState(false);
  const [CaseStudyCategory, setCaseStudyCategory] = useState({});

  const { id } = useParams();

  useEffect(() => {
    axios.get(`${baseApi}case-study/get-case-study-category/${id}`).then((res) => {
      setCaseStudyCategory(res.data.data);
      setIsloading(false);
      console.log('Res', res);
    });
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      page_title: CaseStudyCategory.page_title,
      page_description: CaseStudyCategory.page_description,
      case_study_category: CaseStudyCategory.case_study_category
    },
    validationSchema: Yup.object({
      page_title: Yup.string().required('Please enter page title'),
      page_description: Yup.string().required('Please enter page description'),
      case_study_category: Yup.string().required('Please enter case study category')
    }),
    onSubmit: (values) => {
      setIsloading(true);
      const payload = {
        case_study_category_id: CaseStudyCategory._id,
        case_study_category: values.case_study_category,
        page_title: values.page_title,
        page_description: values.page_description
      };

      axios
        .put(`${baseApi}case-study/update-case-study-category`, payload, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('jwtToken')}`
          }
        })
        .then((res) => {
          setIsloading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  });

  return (
    <Fragment>
      <div className="admin_panel">
        <Dashboard />

        {!isLoading ? (
          <div className="container">
            <div className="col-sm-12">
              {' '}
              <CurrentDate />
              <form onSubmit={formik.handleSubmit} encType="application/json">
                <div className="form-group">
                  <label>
                    <h3>Case Study Category</h3>
                  </label>
                  <input type="text" className="form-control" id="case_study_category" name="case_study_category" {...formik.getFieldProps('case_study_category')} />

                  <span className="text-danger">{formik.touched.case_study_category && formik.errors.case_study_category ? <div>{formik.errors.case_study_category}</div> : null}</span>
                </div>

                <div className="form-group">
                  <label>
                    <h3>Page Title</h3>
                  </label>
                  <input type="text" className="form-control" id="page_title" name="page_title" {...formik.getFieldProps('page_title')} />

                  <span className="text-danger">{formik.touched.page_title && formik.errors.page_title ? <div>{formik.errors.page_title}</div> : null}</span>
                </div>

                <div className="form-group">
                  <label>
                    <h3>Page Description</h3>
                  </label>
                  <input type="text" className="form-control" id="page_description" name="page_description" {...formik.getFieldProps('page_description')} />

                  <span className="text-danger">{formik.touched.page_description && formik.errors.page_description ? <div>{formik.errors.page_description}</div> : null}</span>
                </div>

                <hr />

                <div className="form-group">
                  <input type="submit" className="btn btn-primary" value="Update CS Category" />
                  &nbsp;&nbsp;
                  <Link to="/case-study-category">Back to CS Category</Link>
                </div>
              </form>
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </div>
    </Fragment>
  );
};

export default EditCaseStudyCategory;
